export enum RequisitionSubscriptionStatus {
  Active = 1,
  ScheduledInactive = 2,
  Inactive = 3,
  Pending = 4,
}
